import { connect } from 'react-redux';

import { HiddenBlockButtons, IHiddenBlockStoreButtonsProps, IHiddenBlockDispatchButtonsProps } from './';
import { toggleComplainPopup, restoreOffer } from '../../store/hideOffer';
import {
  ERestoreEventSource,
  selectProductsParams,
  trackHiddenObjects,
  EHideOfferAnalyticsCategory,
} from '../../tracking/hide_offer';

import type { DispatchReduxAction, IState } from '../../store';

export const HiddenBlockButtonsContainer = connect(
  (state: IState): IHiddenBlockStoreButtonsProps => ({
    productParams: selectProductsParams(state),
  }),
  (dispatch: DispatchReduxAction): IHiddenBlockDispatchButtonsProps => ({
    toggleComplainPopup: () => dispatch(toggleComplainPopup(true)),
    restoreOffer: () => dispatch(restoreOffer(ERestoreEventSource.BUTTON)),
  }),
  (store: IHiddenBlockStoreButtonsProps, actions: IHiddenBlockDispatchButtonsProps) => ({
    ...store,
    ...actions,
    toggleComplainPopup: () => {
      trackHiddenObjects({
        action: 'Click_complain',
        category: EHideOfferAnalyticsCategory.HIDE,
        productParams: store.productParams,
      });

      actions.toggleComplainPopup();
    },
  }),
)(HiddenBlockButtons);
